import { useEffect } from "react";

const APP_ORIGIN = "https://bellhopt.com";

function upsertMeta(selector, attributes) {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("meta");
    document.head.appendChild(node);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    node.setAttribute(key, value);
  });
}

function upsertLink(selector, attributes) {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("link");
    document.head.appendChild(node);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    node.setAttribute(key, value);
  });
}

function toAbsoluteUrl(url) {
  if (!url) {
    return APP_ORIGIN;
  }
  if (url.startsWith("http")) {
    return url;
  }
  return `${APP_ORIGIN}${url}`;
}

function SeoHead({
  title,
  description,
  canonical,
  robots = "index,follow",
  ogTitle,
  ogDescription,
  structuredData = [],
}) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    upsertMeta('meta[name="description"]', {
      name: "description",
      content: description,
    });
    upsertMeta('meta[name="robots"]', { name: "robots", content: robots });
    upsertMeta('meta[property="og:title"]', {
      property: "og:title",
      content: ogTitle || title,
    });
    upsertMeta('meta[property="og:description"]', {
      property: "og:description",
      content: ogDescription || description,
    });
    upsertMeta('meta[property="og:type"]', {
      property: "og:type",
      content: "website",
    });
    upsertMeta('meta[property="og:url"]', {
      property: "og:url",
      content: toAbsoluteUrl(canonical),
    });
    upsertLink('link[rel="canonical"]', {
      rel: "canonical",
      href: toAbsoluteUrl(canonical),
    });

    const scripts = structuredData.map((item, index) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seoStructuredData = String(index);
      script.text = JSON.stringify(item);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      document.title = previousTitle;
      scripts.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, [title, description, canonical, robots, ogTitle, ogDescription, structuredData]);

  return null;
}

export default SeoHead;
